import { render, staticRenderFns } from "./RightSection.vue?vue&type=template&id=4d37c3b1&scoped=true&"
import script from "./RightSection.vue?vue&type=script&lang=js&"
export * from "./RightSection.vue?vue&type=script&lang=js&"
import style0 from "./RightSection.vue?vue&type=style&index=0&id=4d37c3b1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d37c3b1",
  null
  
)

export default component.exports